import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DocumentModalService {
  isOpen = false;

  openModal() {
    this.isOpen = true;
  }

  closeModal() {
    this.isOpen = false;
  }
} 